import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import TeamPage from '../pages/TeamBios';
import TermsOfService from '../pages/TermsOfService';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/Team" element={<TeamPage />} />
    <Route path="/TermsOfService" element={<TermsOfService />} />
  </Routes>
);

export default AppRoutes;
